import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../../Assets/javascripts/common/others/SharedDispatcher";
import _ from "underscore";

/*
https://docs.microsoft.com/en-us/previous-versions/windows/internet-explorer/ie-developer/dev-guides/hh673557(v=vs.85)?redirectedfrom=MSDN#feature-detection
https://docs.microsoft.com/en-us/previous-versions/windows/internet-explorer/ie-developer/compatibility/dn304886(v=vs.85)?redirectedfrom=MSDN

- IE on non touch device, don't support touch event nor pointer events: no events
- Edge on non touch device, support pointer event: use touchend (which never triggered)
- IE and Edge on touch tablettes, don't support touch events but only pointer events: use pointer events
- Some browsers on touch device support touch events AND pointer events
- Some browsers on non touch device support pointer events
- Some browsers on touch device support only touch events

IE11 (non touch): use touchend, never triggered
maxTouchPoints == 0
pointer event not supported
touch event not supported

IE11 (touch): use pointer event
maxTouchPoints > 0
pointer event supported
touch event not supported

Edge 12-16 (non touch), Edgium (non touch), Chrome (non touch), Firefox (non touch): use touchend, never triggered
maxTouchPoints == 0
pointer event supported
touch event not supported

Edge 12-16 (touch): use pointer event
maxTouchPoints > 0
pointer event supported
touch event not supported

iOS 11 (touch): use touchend
maxTouchPoints > 0
pointer event not supported
touch event supported

iOS 13 (touch), Edgium (touch), Chrome (touch): use pointer event
maxTouchPoints > 0
pointer event supported
touch event supported
*/
const usePointerEventsForTouch = window.navigator.maxTouchPoints && window.PointerEvent;

export default class extends Backbone.View{
  initialize() {
    if (!this.$el) {
      throw new Error("$el not set.");
    }

    this._map = this._getMap();
    this._activeId = null;

    this._touchMoved = false;
    this._preventClick = false;

    this._touchEndHandler = this._touchEndHandler.bind(this);
    this._openMenu = this._openMenu.bind(this);
    this._closeMenu = this._closeMenu.bind(this);

    this._initializeOutsideEvents();
    SharedDispatcher.on("categorynav:removepanel", this._closeMenu);
  }

  // Comment me for click events
  get events() {
    return {
      [`${usePointerEventsForTouch ? "pointerup" : "touchend"} .js-CategoryNav-item`]: "_touchEndHandler", // only for touch devices
      "mouseenter .js-CategoryNav-item": "_openMenu", // for non-touch devices
      "click .js-CategoryNav-item": "_clickHandler"
    };
  }

  _clickHandler(event){
    if (this._preventClick) {
      event.preventDefault();
      this._preventClick = false;
    }
  }

  _touchEndHandler(event){
    if (!this._touchMoved) {
      this._preventClick = true;
      this._openMenu(event);
    }

  }

  _initializeOutsideEvents() {
      $(document.body)
        .on(usePointerEventsForTouch ? "pointerdown" : "touchstart", () => {this._touchMoved = false})
        .on(usePointerEventsForTouch ? "pointerup" : "touchmove", () => {this._touchMoved = true})
        .on("mouseleave", ".js-CategoryNav-panel", this._closeMenu)
        .on("mouseleave", ".js-CategoryNav", this._checkIfLeftWindow.bind(this))
        .on("mouseenter", ".CategoryNav-extra", this._closeMenu)
        .on("mouseenter", ".js-Header", this._closeMenu)
        .on("click touchstart", ".js-CategoryNav-panel .close", this._closeMenu);
  }

  _openMenu(event) {
      var id = $(event.currentTarget)
      .closest(".js-CategoryNav-item")
      .attr("data-submenu");

      event.preventDefault();
      if (this._activeId == id && event.type !== "mouseenter") { // toggle the menu panel when tap multiple times in the same menu item in touch device
        this._closeMenu(event);
        this._activeId = null;
      } else {
        this.render(id);
    }
  }

  _checkIfLeftWindow(e) {
    const toElement = e.relatedTarget || e.toElement;
    if (!toElement) {
      this._closeMenu();
    }
  }

  _closeMenu() {
    if (this._activeId) {
      this.removeOverlay(); // these two line cause a bug in home page, click event on the menu tab doesnt trigger(dk why...), so we force trigger once more
      $('.js-CategoryNav-wrapper').removeClass("isOpen"); // these two line cause a bug in home page, click event on the menu tab doesnt trigger(dk why...), so we force trigger once more
      $(this._map[this._activeId].panel).remove();
      $(this._map[this._activeId].link).removeClass("CategoryNav-link--active");
      this._activeId = null;
    }
  }

  /**
    * Propagates changes to the dom.
    *
    * @params {Number} activeId - panel id
    */
  render(activeId) {
    // return if already active tab
    if (activeId === this._activeId) {
      return;
    }

    // set new active tab
    this._activeId = activeId;

    // append new active tab
    if (this._activeId) {
      SharedDispatcher.trigger("rayonDropdown:close"); // For closeing the "Rayons" dropdown if it opens
      this.addOverlay();
      if ($('.js-CategoryNav-wrapper').hasClass("isOpen")) {
        $('.js-CategoryNav-wrapper').html(this._map[this._activeId].panel);
      } else {
        $('.js-CategoryNav-wrapper').append(this._map[this._activeId].panel);
        $('.js-CategoryNav-wrapper').addClass("isOpen");
      }

      $(this._map[this._activeId].item)
        .find(".js-CategoryNav-link")
        .addClass("CategoryNav-link--active");

    } else {
      $('.js-CategoryNav-wrapper').removeClass("isOpen");
      this.removeOverlay();
    }
  }

  _getMap() {
    let items = this.$(".js-CategoryNav-item");
    let map = {};

    _.each(items, function (item, index) {
      let panel = item.querySelector(".js-CategoryNav-panel");
      let link = item.querySelector(".js-CategoryNav-link");

      if (panel) {
        panel.parentNode.removeChild(panel);
        map[index] = {
          item: item,
          link: link,
          panel: panel
        };

        item.setAttribute("data-submenu", index);
      }
    });

    return map;
  }

  /**
  * Add overlay.
  *
  * @returns {Nothing}
  */
  addOverlay() {
    SharedDispatcher.trigger("overlay:show", { cssModifier: "menu" });
  }

  /**
    * Remove overlay.
    *
    */
  removeOverlay() {
    SharedDispatcher.trigger("overlay:hide");
  }
}
